import React, { useState } from 'react';
import { motion } from 'framer-motion';
import copy from 'copy-to-clipboard';
import Layout from '../components/Layout';
import Textarea from '../components/Textarea';
import Button from '../components/Button';
import { removeCharacters } from '../utils/textUtils';

const CharacterRemover: React.FC = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [options, setOptions] = useState({
    specialChars: true,
    emoji: true,
    numbers: false,
    english: false,
    korean: false,
  });
  const [showToast, setShowToast] = useState(false);

  const handleRemove = () => {
    let cleaned = text;

    if (options.specialChars) {
      cleaned = removeCharacters.specialChars(cleaned);
    }
    if (options.emoji) {
      cleaned = removeCharacters.emoji(cleaned);
    }
    if (options.numbers) {
      cleaned = removeCharacters.numbers(cleaned);
    }
    if (options.english) {
      cleaned = removeCharacters.english(cleaned);
    }
    if (options.korean) {
      cleaned = removeCharacters.korean(cleaned);
    }

    setResult(cleaned);
  };

  const handleCopy = () => {
    copy(result);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  const toggleOption = (key: keyof typeof options) => {
    setOptions((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <Layout showBackButton>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32"
        >
          <h1 className="text-4xl font-bold text-textPrimary mb-8">
            특수문자 제거
          </h1>
          <p className="text-textSecondary">원하는 문자만 남기세요</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-24"
        >
          <label className="block text-textSecondary mb-8 text-sm">
            입력 텍스트
          </label>
          <Textarea
            value={text}
            onChange={setText}
            placeholder="Hello! @World 123 😊"
          />
        </motion.div>

        {text && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-24"
          >
            <div className="bg-surface rounded-large p-24 mb-24">
              <h3 className="text-lg font-bold text-textPrimary mb-16">
                제거 옵션 (다중 선택)
              </h3>
              <div className="space-y-12">
                <label className="flex items-center gap-8 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={options.specialChars}
                    onChange={() => toggleOption('specialChars')}
                    className="w-16 h-16"
                  />
                  <span className="text-textPrimary">특수문자 제거</span>
                </label>
                <label className="flex items-center gap-8 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={options.emoji}
                    onChange={() => toggleOption('emoji')}
                    className="w-16 h-16"
                  />
                  <span className="text-textPrimary">이모지 제거</span>
                </label>
                <label className="flex items-center gap-8 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={options.numbers}
                    onChange={() => toggleOption('numbers')}
                    className="w-16 h-16"
                  />
                  <span className="text-textPrimary">숫자 제거</span>
                </label>
                <label className="flex items-center gap-8 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={options.english}
                    onChange={() => toggleOption('english')}
                    className="w-16 h-16"
                  />
                  <span className="text-textPrimary">영문 제거</span>
                </label>
                <label className="flex items-center gap-8 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={options.korean}
                    onChange={() => toggleOption('korean')}
                    className="w-16 h-16"
                  />
                  <span className="text-textPrimary">한글 제거</span>
                </label>
              </div>
              <div className="mt-16">
                <Button onClick={handleRemove}>제거하기</Button>
              </div>
            </div>

            {result && (
              <div>
                <label className="block text-textSecondary mb-8 text-sm">
                  정리된 텍스트
                </label>
                <Textarea value={result} onChange={setResult} />
                <div className="mt-12">
                  <Button onClick={handleCopy}>결과 복사</Button>
                </div>
              </div>
            )}
          </motion.div>
        )}

        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="fixed bottom-32 left-1/2 transform -translate-x-1/2 bg-textPrimary text-white px-24 py-12 rounded-medium shadow-lg"
          >
            ✓ 복사됨
          </motion.div>
        )}
      </div>
    </Layout>
  );
};

export default CharacterRemover;
